import BankCodeInput from "./bankCodeInput";

export default class FwInput<TTarget> extends BankCodeInput<TTarget> {
  //A Fedwire (or ABA) code is a bank code used in the United States. Fedwire/ABA codes are always nine (9) digits in length.
  protected mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
}
